import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IPreferredSupplier } from '../interfaces/preferred-supplier';
import { IPreferredSupplierFilter } from '../interfaces/preferred-supplier-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class PreferredSupplierChangeStatus extends EditService<
  IPreferredSupplier,
  IPreferredSupplierFilter
> {
  url = '/api/preferredsuppliers';
  entityTitle = 'PreferredSupplierChangeStatus';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  get(id: number): Promise<IPreferredSupplier> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
    return this.handleRequest(
      this.http.post<IPreferredSupplier>(this.url + '/changestatus', id, { headers: headers }),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }
}
